import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Router
import { getRoute } from '../../entry/routes';

import config from '../../config';

// Styles
import styles from './Nav.styl';

const cx = classNames.bind(styles);

export default function Nav(props) {
  const { className, onClose } = props;

  const sailplayType = useSelector(state => state.city.userCity.sailplay?.type);
  const isOldLoyalty = useMemo(() => sailplayType === 'gifts', [sailplayType]);

  const links = [
    {
      to: getRoute('home'),
      id: 'header.nav.menu',
      enabled: true,
    },
    {
      to: getRoute('stock'),
      id: 'header.nav.stock',
      enabled: true,
    },
    {
      to: getRoute('papabonus'),
      id: 'header.nav.papabonus',
      enabled: true,
    },
    {
      to: getRoute('contacts'),
      id: 'header.nav.contacts',
      enabled: true,
    },
  ];

  return (
    <nav className={cx('Nav', className)}>
      {links
        .filter(link => link.enabled)
        .map(link => (
          <NavLink
            key={link.id}
            to={link.to}
            className={cx('Nav__link')}
            activeClassName={cx('Nav__link_active')}
            onClick={onClose}
            exact
          >
            <FormattedMessage id={link.id} />
          </NavLink>
        ))}
    </nav>
  );
}

Nav.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

Nav.defaultProps = {
  className: '',
  onClose: () => null,
};
